import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "aceFileSize"
})
export class AceFileSizePipe implements PipeTransform {
  private _sizes = ["B", "kB", "MB", "GB"];
  transform(size: number): string {
    if (size === 0) {
      return "0";
    }
    const i = Math.floor(Math.log(size) / Math.log(1024));
    return Math.round(size / Math.pow(1024, i)).toString() + " " + this._sizes[i];
  }
}
